import React, { Component } from "react";
import AbilityTestContent from "./AbilityTestContent";
import { Form, FormControl } from "react-bootstrap";
import QnASideBarRight from "../questionanswer/QnASideBarRight";
import BlogSideBarRight from "../blogs/BlogSideBarRight";

class AbilityTest extends Component {
  render() {
    return (
      <div className="container-fluid">
        <div className="row flex-xl-nowrap">
          <aside className="d-none d-xl-block col-xl-2 pt-3">
                    <div className="position-sticky" style={{ top: "1rem" }}>
                      <BlogSideBarRight />
                    </div>
                  </aside>
          <main
            className="col-12 col-md-9 col-xl-8 py-md-3 pl-md-5 bd-content"
            role="main"
          >
            <AbilityTestContent />
          </main>
          <div className="col-6 col-md-2 clo-xl-2 mb-2 border-left">
            <QnASideBarRight />
          </div>
        </div>
      </div>
    );
  }
}

export default AbilityTest;
